import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { Container, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import PropTypes from "prop-types";
import { propTypes } from "react-bootstrap/esm/Image";
import { generate30MinTimeSlots, formatBarcode } from "../../utils/utils";

const SimpleTable = ({ data = {}, editable = false, onUpdate, rejectPath }) => {
  const transformData = (data) => {
    if (!data) return [];

    const fieldMap = {
      full_name: localStorage.getItem("selectedService")==="healthCare" ? "Patient name":"Participant name",
      booking_id: "Booking ID",
      dob: "Date of birth",
      test_type: "Test type",
      primary_barcode: "SST barcode",
      secondary_barcode: "EDTA barcode",
      sample_collection_date: "Date",
      sample_collection_time: "Time",
      number_of_attempts: "No. of attempts",
      store_location: "Store location",
    };

    return Object.entries(data)
      .filter(([key, value]) => {
        if (key === "secondary_barcode") {
          return !!value;
        }
        return fieldMap.hasOwnProperty(key);
      })
      .map(([key, value]) => ({
        id: key,
        header: fieldMap[key],
        value: key === "sample_collection_date" && value
        ? moment(value, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY")
        : value || "",
        editable: isEditableField(key),
      }));
  };

  const isEditableField = (fieldName) => {
    const nonEditableFields = [
      "full_name",
      "booking_id",
      "dob",
      "test_type",
      "store_location",
      "secondary_barcode",
    ];
    return !nonEditableFields.includes(fieldName);
  };

  const transformedData = transformData(data);

const customEditor = (onUpdate, props) => {

  let dateObj = null;
  
  if (props.value) {
    let parsedDate = moment(props.value, "DD/MM/YYYY");
    if (!parsedDate.isValid()) {
      parsedDate = moment(props.value, "YYYY-MM-DD");
    }
    
    dateObj = parsedDate.isValid() ? parsedDate.toDate() : null;
  }

  return (
    <DatePicker
      dateFormat="dd/MM/yyyy"
      onChange={
        (date) => onUpdate(date ? moment(date).format("YYYY-MM-DD") : "")
      }
      selected={dateObj}
      shouldCloseOnSelect={false} 
      placeholderText="Select date"
    />
  );
};

  const timeEditor = (onUpdate, props) => {
    const allowedTimes = generate30MinTimeSlots();
  
    return (
      <select
        className="form-control custom-time-select"
        defaultValue={props.value}
        onChange={(e) => onUpdate(e.target.value)}
      >
        {allowedTimes.map((time) => (
          <option key={time} value={time}>
            {time}
          </option>
        ))}
      </select>
    );
  };
  

  const attemptsEditor = (onUpdate, props) => (
    <select
      defaultValue={props.value}
      onChange={(e) => onUpdate(Number.parseInt(e.target.value, 10))}
    >
      {[1, 2].map((num) => (
        <option key={num} value={num}>
          {num}
        </option>
      ))}
    </select>
  );

  const defaultEditor = (onUpdate, props) => (
    <input
      defaultValue={props.value}
      onBlur={(e) => onUpdate(e.target.value)}
      type="text"
    />
  );

  const barcodeEditor = (onUpdate, props) => (
    <input
      defaultValue={props.value}
      onBlur={(e) => onUpdate(formatBarcode(e.target.value))}
      type="text"
    />
  );

  const columns = [
    {
      dataField: "header",
      text: "Field",
      editable: false,
      headerClasses: "d-none",
      classes: "font-weight-bold",
    },
    {
      dataField: "value",
      text: "Value",
      headerClasses: "d-none",
      editorRenderer: (editorProps, value, row) => {
        if (row.id === "sample_collection_date") {
          return customEditor(editorProps.onUpdate, { value });
        } else if (row.id === "sample_collection_time") {
          return timeEditor(editorProps.onUpdate, { value });
        } else if (row.id === "number_of_attempts") {
          return attemptsEditor(editorProps.onUpdate, { value });
        } else if (row.id === "secondary_barcode") {
          return barcodeEditor(editorProps.onUpdate, { value });
        }
        return defaultEditor(editorProps.onUpdate, { value });
      },
      editable: (cell, row) => row.editable && editable,
      classes: (cell, row) => {
        let className = "";
        if (!rejectPath) {
          className = row.editable ? "" : "non-editable";
        }
        return className;
      },
    },
  ];

  return (
    <Container className="p-0">
      <Row>
        <Col xl={7}>
          <div className="appointment-confirmation-table px-4">
            <BootstrapTable
              cellEdit={
                editable &&
                cellEditFactory({
                  afterSaveCell: (oldValue, newValue, row, column) => {
                    if (onUpdate) {
                      onUpdate(row.id, newValue);
                    }
                  },
                  blurToSave: true,
                  mode: "click",
                })
              }
              columns={columns}
              data={transformedData}
              keyField="id"
            />
          </div>
        </Col>
        <Col xl={5}></Col>
      </Row>
    </Container>
  );
};
SimpleTable.propTypes = {
  data: PropTypes.object,
  editable: PropTypes.bool,
  onUpdate: PropTypes.func,
  rejectPath: PropTypes.string,
  value: propTypes.any
};

export default SimpleTable;
